export default __webpack_public_path__ + "static/logo-nopad-e1510396c53b23ba5e62292cd08201f6.svg";